import React, {useEffect, useMemo} from 'react';
import queryString from 'query-string';
import {useDispatch, useSelector} from 'react-redux';

import {labels} from '../../../../../util/utils';
import {
	projectSessionKeys,
	StandardColumns,
	standardColumnsExternalUser,
	scrollableColumns,
	tablePaginationSizeOptions
} from '../../../../../util/uiconstants';
import getUserPermissions from '../../getUserPermissions';
import selectAccessPermissions from '../../../../../reducers/Project/selectors/selectAccessPermissions';
import {selectContact} from '../../../../../actions/ContactDB';

import {loadStorage, saveStorage} from '../../../../Common/localStorage';
import CommonContactTable from '../../../../Common/ContactTable';

import columns from '../../../../Common/ContactTable/columns';

const ContactTable = ({contacts, entityId}) => {
	const selectedContacts = useSelector((store) => store?.contacts?.selected);
	const customizeColumns = useSelector(({contacts}) => contacts?.customizeColumns);
	const userPreferences = useSelector((store) => store.userPreferences);
	const project = useSelector(({project}) => project);
	const {groupRiskAssessmentAccess} = selectAccessPermissions(project);
	const {selectContactPermission} = useSelector((state) =>
		getUserPermissions({
			userPreferences: state.userPreferences,
			entities: state.project?.orgStructure,
			userList: state.project?.users
		})
	);

	const query = queryString.parse(location.search.toLowerCase());
	const projectId = query?.projectid ? query.projectid : '';
	const projectSessionKey = `${projectSessionKeys.userColumns}_${projectId}`;

	const isInternal = useMemo(
		() =>
			project.users?.filter((user) => user.userType === 'Member' && user.userId === userPreferences.userId) ?? false,
		[project, userPreferences]
	);

	const dispatch = useDispatch();

	const handleSelection = (selected) => dispatch(selectContact(selected));

	useEffect(() => {
		const selectedColumns = loadStorage(projectSessionKey);
		if (selectedColumns) {
		} else {
			if (isInternal?.length > 0) {
				saveStorage(projectSessionKey, StandardColumns.columns);
			} else {
				saveStorage(projectSessionKey, standardColumnsExternalUser.columns);
			}
		}
	}, []);

	const props = {
		selectedContacts: selectedContacts,
		activateProfileModal: true,
		selectContactPermission,
		tableConfig: {
			data: contacts.map((contact) => ({...contact, id: contact.userId})),
			columns: columns(labels, {entityId, isInternal, customizeColumns, groupRiskAssessmentAccess}).contactTable,
			pagination: true,
			paginationOptions: tablePaginationSizeOptions,
			scrollableColumns,
			selected: selectedContacts,
			onSelect: handleSelection,
			cellHeightAuto: true,
			labels: {
				emptyMessage: labels.thereIsNoDataToDisplay,
				show: labels.show,
				first: labels.firstPage,
				last: labels.lastPage,
				previous: labels.prevPage,
				next: labels.nextPage,
				yesLabel: labels.yes,
				noLabel: labels.no,
				scrollColNext: labels.viewMoreColumns,
				scrollColPrev: labels.viewMoreColumns
			}
		}
	};

	return customizeColumns && <CommonContactTable {...props} />;
};

ContactTable.propTypes = {};

export default ContactTable;
